<template>
  <div class="card shadow-sm w-100 mb-3">
    <div class="card-header d-flex justify-content-between align-items-center flex-wrap">
      <h5 class="mb-0">⚙️ Tipos de Análisis</h5>
      <button v-if="!showForm" class="btn btn-success btn-sm w-100 w-md-auto mb-2 mb-md-0" @click="nuevoTipoAnalisis">
        <font-awesome-icon icon="plus" class="me-1" /> Nuevo tipo de análisis
      </button>
    </div>

    <div class="card-body">
      <!-- Formulario -->
      <form v-if="showForm" @submit.prevent="submitTipoAnalisis" class="mb-4">
        <div class="row g-2">
          <div class="col-12 col-md-6">
            <label class="form-label">Nombre del Tipo de Análisis</label>
            <input type="text" class="form-control" v-model="tipoAnalisis.nombre" required />
          </div>
          <div class="col-12 col-md-6">
            <label class="form-label">Comentarios</label>
            <textarea class="form-control" v-model="tipoAnalisis.descripcion" rows="2" placeholder="Comentarios opcionales"></textarea>
          </div>
        </div>
        <div class="text-end mt-3">
          <button type="submit" class="btn btn-success">
            <font-awesome-icon icon="save" class="me-1" />
            {{ tipoAnalisis.id ? 'Actualizar' : 'Guardar' }}
          </button>
          <button type="button" class="btn btn-secondary ms-2" @click="cancelarForm">
            Cancelar
          </button>
        </div>
      </form>

      <!-- Lista -->
      <div v-if="tiposAnalisis.length" class="list-group">
        <div class="list-group-item d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center" v-for="tipo in tiposAnalisis" :key="tipo.id">
          <div class="flex-grow-1">
            <span class="fw-bold text-break">{{ tipo.nombre }}</span>
            <span v-if="tipo.descripcion" class="text-muted small ms-2 text-break">({{ tipo.descripcion }})</span>
          </div>
          <div class="d-flex flex-row mt-2 mt-md-0">
            <button class="btn btn-sm btn-outline-primary me-2" @click="editTipoAnalisis(tipo)">
              <font-awesome-icon icon="pen" />
            </button>
            <button class="btn btn-sm btn-outline-danger" @click="deleteTipoAnalisis(tipo.id)">
              <font-awesome-icon icon="trash" />
            </button>
          </div>
        </div>
      </div>
      <div v-else class="alert alert-info mt-3 mb-0">No hay tipos de análisis registrados.</div>

      <div v-if="error" class="alert alert-danger mt-3">{{ error }}</div>
    </div>
  </div>
</template>

<script>
import axios from '@/axios'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'TipoAnalisisAdmin',
  components: { FontAwesomeIcon },
  data() {
    return {
      tipoAnalisis: { nombre: '', descripcion: '' },
      tiposAnalisis: [],
      error: null,
      showForm: false
    }
  },
  methods: {
    async fetchTiposAnalisis() {
      try {
        const response = await axios.get('/api/tipo_analisis')
        this.tiposAnalisis = response.data
      } catch (error) {
        this.error = 'Error al cargar los tipos de análisis'
        console.error(error)
      }
    },
    nuevoTipoAnalisis() {
      this.resetForm()
      this.showForm = true
    },
    editTipoAnalisis(tipo) {
      this.tipoAnalisis = { ...tipo }
      if (!this.tipoAnalisis.descripcion) this.tipoAnalisis.descripcion = ''
      this.showForm = true
    },
    resetForm() {
      this.tipoAnalisis = { nombre: '', descripcion: '' }
    },
    cancelarForm() {
      this.resetForm()
      this.showForm = false
    },
    async submitTipoAnalisis() {
      try {
        if (this.tipoAnalisis.id) {
          await axios.put(`/api/tipo_analisis/${this.tipoAnalisis.id}`, this.tipoAnalisis)
        } else {
          await axios.post('/api/tipo_analisis', this.tipoAnalisis)
        }
        this.resetForm()
        this.showForm = false
        this.fetchTiposAnalisis()
      } catch (error) {
        this.error = 'Error al guardar el tipo de análisis'
        console.error(error)
      }
    },
    async deleteTipoAnalisis(id) {
      if (!confirm('¿Eliminar este tipo de análisis?')) return
      try {
        await axios.delete(`/api/tipo_analisis/${id}`)
        this.fetchTiposAnalisis()
      } catch (error) {
        this.error = 'Error al eliminar'
        console.error(error)
      }
    }
  },
  mounted() {
    this.fetchTiposAnalisis()
  }
}
</script>

<style scoped>
.list-group-item {
  padding: 0.75rem 1rem;
}
@media (max-width: 767.98px) {
  .card-header h5 {
    font-size: 1.1rem;
  }
  .list-group-item {
    font-size: 0.98rem;
  }
}
</style>
